import { useCurrentWorkspaceId } from '@/store/auth.store';
import { useWorkspaces } from './useWorkspaces';
import type { WorkspaceRole } from '../types/workspace.types';

/**
 * Returns the current user's workspace role in the selected workspace,
 * or null if no workspace is selected or data is still loading.
 */
export function useCurrentWorkspaceRole(): WorkspaceRole | null {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const { data: workspaces = [] } = useWorkspaces();

  if (!currentWorkspaceId) return null;

  const workspace = workspaces.find((w) => w.id === currentWorkspaceId);
  return workspace?.workspaceRole ?? null;
}
